export interface IGetTemplateByIdRequestPayload {
    templateId: string;
    sessionId: string;
}

export enum TemplateOrTagsModalTabKey {
    TEMPLATE = 'template',
    TAGS = 'tags',
}

export enum TemplateChildFields {
    FILL = 'fill',
    COLORS_REPLACE = 'colorsReplace',
    COLOR = 'color',
    BORDER_COLOR = 'borderColor',
    STROKE = 'stroke',
}
